export default class LocationFieldType
{
	static POSTAL_CODE = 50;
	static ISO_3166_1_ALPHA_2 = 1000;
}